import { makePrivateRequestAsUser, makePublicRequest } from "./managers/requestBuilder";
import { getAuthToken } from "./managers/store";
import { jwtDecode } from 'jwt-decode';

export const SHARING_LINK_NEVER_EXPIRE = Symbol('SHARING_LINK_NEVER_EXPIRE');

/**
 * Get jwt token for the requested resource - currently just videos
 * @param {number} exp
 * @param {string} access - "private"|"public"
 * @param {Object} tokenData -
 * @returns {string} jwt token for shared resource
 */
 export const getSharingJWT = makePrivateRequestAsUser(async ({ makePrivateRequest }, exp, access, tokenData) => {
    let expiryData = {};

    if (access === "public") {
        if (exp === SHARING_LINK_NEVER_EXPIRE) {
            expiryData = { noExpiry: true };
        } else if (exp?.type === "ttl" && exp?.value) {
            expiryData = { validSeconds: exp.value };
        } else if (exp?.type === "timestamp" && exp?.value) {
            expiryData = { expiryTimestamp: exp?.value };
        } else {
            throw new Error("invalid expiry config for public shared link");
        }
    } 

    const { data } = await makePrivateRequest(
        'auth',
        'POST',
        '/jwt/sign',
        {
            data: {
                ...expiryData,
                type: "video",
                access,
                ...tokenData
            }
        }
    );

    return data;
});


export const decodeJWT = async (token) => {
    const authToken = getAuthToken();

    try {
        const decodedLocal = jwtDecode(token);

        const { data } = await makePublicRequest(
            'auth',
            'GET',
            '/jwt/verify',
            {   
                region: decodedLocal.region,
                headers: {
                    Authorization: `${authToken ? `ManythingToken ${authToken} ` : ''}SharedToken ${token}`
                }
            },
        );

        // Some tokens may not have metadata due to needing to shorten the JWT
        if (!data.metadata) {
            const { data: metadata } = await makePublicRequest(
                'auth',
                'GET',
                '/jwt/metadata',
                {   
                    region: decodedLocal.region,
                    headers: {
                        Authorization: `SharedToken ${token}`
                    }
                },
            );

            data.metadata = metadata;
        }
    
        return [data, null];
    } catch (err) {
        return [null, err.response?.data?.error ?? err.response?.data ?? err.name];
    }
};